<template>
  <div class="relative h-full w-full">
    <v-window v-model="currentImageIndex" continuous class="h-100">
      <v-window-item v-for="(img, i) in images" :key="i">
        <v-img :src="img" :alt="title + ' - Imagem ' + (i + 1)" height="550" cover>
          <slot></slot>
        </v-img>
      </v-window-item>
    </v-window>
    
    <button 
      @click.stop="$emit('navigate', 'prev')" 
      class="absolute top-1/2 left-0 transform -translate-y-1/2 z-30 p-4 opacity-70 hover:opacity-100 transition-opacity"
    >
      <v-icon size="x-large" color="white">mdi-chevron-left</v-icon>
    </button>
    <button 
      @click.stop="$emit('navigate', 'next')" 
      class="absolute top-1/2 right-0 transform -translate-y-1/2 z-30 p-4 opacity-70 hover:opacity-100 transition-opacity"
    >
      <v-icon size="x-large" color="white">mdi-chevron-right</v-icon>
    </button>
  </div>
</template>

<script setup>
import { ref, watch, onBeforeUnmount, defineEmits } from 'vue';

// Define o evento 'navigate' que o componente emitirá
const emit = defineEmits(['navigate']);

const props = defineProps({
  images: { type: Array, required: true },
  title: { type: String, required: true },
  isActive: { type: Boolean, default: false }
});

const currentImageIndex = ref(0);
let timer = null;
const intervalDuration = 3000; // 3 segundos

function startAutoplay() {
  if (timer) clearInterval(timer);
  
  // Verifica se há mais de uma imagem para fazer o autoplay
  if (props.images.length > 1) {
    timer = setInterval(() => {
      currentImageIndex.value = (currentImageIndex.value + 1) % props.images.length;
    }, intervalDuration);
  }
}

function stopAutoplay() {
  if (timer) clearInterval(timer);
  timer = null;
}

watch(() => props.isActive, (newVal) => {
  if (newVal) {
    startAutoplay();
  } else {
    stopAutoplay();
    currentImageIndex.value = 0; 
  }
}, { immediate: true });

onBeforeUnmount(stopAutoplay);
</script>

<style scoped>
/* Adicione estilos para garantir que o contêiner do LotImagePlayer ocupe todo o espaço */
.h-100 {
  height: 100%;
}
</style>